import slug from '../util/slug'

export default class Subnavigation {
  constructor ($el, $headlines) {
    this.$el = $el
    this.$headlines = $headlines
    this.buildSubnavigation()
  }

  buildSubnavigation () {
    let headlineMap = {}
    this.$headlines.each((_idx, elem) => {
      let $headline = $(elem).text()
      let idText = 'subnav_' + slug($headline)
      headlineMap[idText] = $headline
      $(elem).attr('id', idText)
    })
    $.each(headlineMap, (id, text) => {
      let li = `<li class="widget-subnavigation__list-item"><a href="#${id}">${text}</a></li>`
      this.$el.append(li)
    })
  }
}
